import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cd-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent implements OnInit {
  
  @Input() placeholder: string;
  @Input() searchText: string;

  @Output() search = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  searchThis(){
    console.log('searchThis:'+this.searchText);
    this.search.emit(this.searchText);
  }

}
